import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    // Cargar configuración desde localStorage o usar valores por defecto
    const savedSettings = localStorage.getItem('b2b_settings');
    return savedSettings ? JSON.parse(savedSettings) : {
  companyName: 'CHIRAK CHILE',
      companyLogoUrl: '', // Puedes poner un URL de logo por defecto aquí
      phone: '+ 562 22444141',
  email: 'gerentereceptivo@chirak.cl',
      address: 'Cl. Galvarino Gallardo 1941, Providencia - Santiago – Chile',
      social: {
        facebook: '#',
        twitter: '#',
        linkedin: '#',
        instagram: '#',
      },
      sliderInfo: [
        { title: 'Hoteles Disponibles', value: 'Reserva entre más de 100 hoteles en los mejores destinos de Chile.', icon: 'Package', color: 'from-blue-500 to-blue-600' },
        { title: 'Experiencias Únicas', value: 'Tours, excursiones y actividades para todos los gustos.', icon: 'Star', color: 'from-yellow-500 to-yellow-600' },
        { title: 'Clientes Satisfechos', value: 'Más de 10.000 viajeros felices cada temporada.', icon: 'Users', color: 'from-purple-500 to-purple-600' },
        { title: 'Ofertas Exclusivas', value: 'Promociones y descuentos especiales para agencias y grupos.', icon: 'TrendingUp', color: 'from-red-500 to-red-600' },
        { title: 'Paquetes Turísticos', value: 'Programas completos: alojamiento, traslados y actividades.', icon: 'Folder', color: 'from-green-500 to-green-600' },
        { title: '¡Nueva Temporada!', value: 'Descubre los destinos top y novedades 2025.', icon: '', color: 'from-pink-500 to-red-500', imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400' }
      ],
      popups: [
        {
          id: 1,
          title: '¡Bienvenido a CHIRAK CHILE!',
          content: 'Explora hoteles, reserva experiencias y vive el turismo a otro nivel.',
          imageUrl: 'https://images.unsplash.com/photo-1521737711867-e3b973753422?w=400',
          buttonText: 'Ver Hoteles',
          buttonLink: '/',
          active: true,
          trigger: 'onLoad',
          showOnPages: ['/']
        },
        {
          id: 2,
          title: 'Oferta Especial para Viajeros',
          content: 'Aprovecha descuentos exclusivos en reservas anticipadas y paquetes turísticos.',
          imageUrl: '',
          buttonText: 'Ver Ofertas',
          buttonLink: '#',
          active: false,
          trigger: 'onLoad',
          showOnPages: ['/']
        },
        {
          id: 3,
          title: '¡Nuevos Destinos 2025!',
          content: 'Ya puedes reservar en los destinos más solicitados de la temporada.',
          imageUrl: '',
          buttonText: 'Explorar Destinos',
          buttonLink: '/destinos',
          active: false,
          trigger: 'onLoad',
          showOnPages: ['/admin']
        }
      ]
    };
  });

  useEffect(() => {
    localStorage.setItem('b2b_settings', JSON.stringify(settings));
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings(prevSettings => ({ ...prevSettings, ...newSettings }));
  };

  const value = {
    settings,
    updateSettings,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};